var ajax = new XMLHttpRequest();
ajax.open("get", "//www.seidoshop.com/cdn/shop/t/42/assets/site-js-countries.json?v=12640871635132238801709170564", true);
ajax.send();
ajax.addEventListener('load', function (e) {

  var infoCountriesJSon;
  infoCountriesJSon = JSON.parse(this.responseText);



  (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
    /*\
    |*|
    |*|  :: cookies.js ::
    |*|
    |*|  A complete cookies reader/writer framework with full unicode support.
    |*|
    |*|  Revision #1 - September 4, 2014
    |*|
    |*|  https://developer.mozilla.org/en-US/docs/Web/API/document.cookie
    |*|  https://developer.mozilla.org/User:fusionchess
    |*|
    |*|  This framework is released under the GNU Public License, version 3 or later.
    |*|  http://www.gnu.org/licenses/gpl-3.0-standalone.html
    |*|
    |*|  Syntaxes:
    |*|
    |*|  * docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
    |*|  * docCookies.getItem(name)
    |*|  * docCookies.removeItem(name[, path[, domain]])
    |*|  * docCookies.hasItem(name)
    |*|  * docCookies.keys()
    |*|
    \*/

    var docCookies = {
      getItem: function (sKey) {
        if (!sKey) { return null; }
        return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
      },
      setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
        var sExpires = "";
        if (vEnd) {
          switch (vEnd.constructor) {
            case Number:
              sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
              break;
            case String:
              sExpires = "; expires=" + vEnd;
              break;
            case Date:
              sExpires = "; expires=" + vEnd.toUTCString();
              break;
          }
        }
        document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
        return true;
      },
      removeItem: function (sKey, sPath, sDomain) {
        if (!this.hasItem(sKey)) { return false; }
        document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
        return true;
      },
      hasItem: function (sKey) {
        if (!sKey) { return false; }
        return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
      },
      keys: function () {
        var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
        for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
        return aKeys;
      }
    };

    module.exports = docCookies;
    },{}],2:[function(require,module,exports){
    module.exports = {
      /*
        Array Functions
      */
      // For each item in Array
      each: function (arr, callback, ctx) {
        for (var i = 0; i < arr.length; i++) {
          ctx = ctx || arr[i];
          callback.apply(ctx, [arr[i], i]);
        }
      },

      // For each item in Object
      eachIn: function (obj, callback, ctx) {
        for (var k in obj) {
          if (obj.hasOwnProperty(k)) {
            ctx = ctx || obj[k];
            callback.apply(ctx, [obj[k], k]);
          }
        }
      },

      // Return true if item is in Array
      inArray: function (needle, haystack) {
        var found = false;
        this.each(haystack, function (hay) {
          if (needle === hay) found = true;
        });
        return found;
      },

      // return the last item in the array
      last: function (arr) {
        return arr[arr.length - 1];
      },


      /*
        String Functions
      */
      // Captialse the first char in String
      capitalise: function (str) {
        return str[0].toUpperCase() + str.slice(1);
      },


      /*
        Event Functions
      */
      // Run code when the page is ready
      ready: function (callback, ctx) {
        if (typeof callback !== 'function') return;

        if (document.readyState !== 'loading') {
          callback.apply(ctx);
        } else {
          document.addEventListener('DOMContentLoaded', function () {
            callback.apply(ctx);
          });
        }
      },

      // CUSTOM FUNC for seido to trigger things when the core is ready
      readyCore: function (callback, ctx) {
        if (typeof callback !== 'function') return;

        if (window.SeidoCore.ready) {
          callback.apply(ctx);
        } else {
          window.SeidoCore.on('ready', function () {
            callback.apply(ctx);
          });
        }
      },

      // CUSTOM FUNC for seido to trigger things when the product is ready
      readyProduct: function (callback, ctx) {
        if (typeof callback !== 'function') return;

        if (window.ProductCore.ready) {
          callback.apply(ctx);
        } else {
          window.ProductCore.on('ready', function () {
            callback.apply(ctx);
          });
        }
      },

      // Make thing not happen until finished?
      // i.e. don't act on every window resize event, just the last one when we need it.
      debounce: function (callback, wait, ctx) {
        var timeout, timestamp, args;
        wait = wait || 100;

        var later = function() {
          var last = new Date().getTime() - timestamp;
          if (last < wait && last >= 0) {
            timeout = setTimeout(later, wait - last);
          } else {
            timeout = null;
            callback.apply(ctx, args);
          }
        };

        return function () {
          ctx = ctx || this;
          args = arguments;
          timestamp = new Date().getTime();
          if (!timeout) timeout = setTimeout(later, wait);
        };
      },

      // Don't swamp us with events
      // good for things like scroll and resize
      throttle: function (callback, limit, ctx) {
        limit = limit || 200;
        var wait = false;
        return function () {
          if (!wait) {
            callback.apply(ctx, arguments);
            wait = true;
            setTimeout(function () {
              wait = false;
            }, limit);
          }
        }
      },

      // Get the value of a url parameter
      getUrlParameter: function (sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

        for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');
          if (sParameterName[0] === sParam) {
              return sParameterName[1] === undefined ? true : sParameterName[1];
          }
        }
      },

      // Convenience function to add the money span markup.
      moneying: function(price){
        // if("USD CAD EUR GBP AUD CHF HKD NZD SGD KRW RUB" != '')
        //   var newPrice =  Currency.formatMoney(price,Currency.moneyFormats[CoreInit.ShopCurrency]["money_with_currency_format"]);
        // else
        //   var newPrice =  "&#165;" + ((price/100).toLocaleString('ja-JP', {  currency: 'JPY' }));
        // return '<span class="money" data-currency-'+CoreInit.ShopCurrency.toLowerCase()+'="'+newPrice+'">'+newPrice+'</span>';

        var currentCurrency = document.querySelector('[data-currency-primary]').getAttribute("data-currency-primary");
        var daPrice =  Currency.formatMoneyUpdateCart(price,Currency.moneyFormats[currentCurrency]["money_with_currency_format"]);

        return '<span data-currency-'+currentCurrency+'="'+daPrice+'">'+daPrice+'</span>';

      },

      // Get height of element (with padding and marging)
      outerHeight: function(el){
        var height = el.offsetHeight;
        var style = getComputedStyle(el);
        height += parseInt(style.marginTop) + parseInt(style.marginBottom);
        return height;
      },

      //
      smoothScroll: function(target){
        var yPosition = - window.getComputedStyle(target, null).marginTop.replace("px", "");
        while(target) {
          // yPosition += (target.offsetTop - window.getComputedStyle(target, null).marginTop.replace("px", ""));
          yPosition += target.offsetTop;
          target = target.offsetParent;
        }
        var windowSize = window.getComputedStyle(document.body,':after').getPropertyValue('content').replace(/['"]/g, '');
        //In XS the header is already fixed and in SM no header
        //In the other cases when the header is fixed the logo height is 0 or the difference after scrolling is around 65px
        // yPosition -= (windowSize == "xs" || document.querySelector('.site-logo-wrapper').offsetHeight == 0) ? parseInt(document.querySelector(".site-header-menu").offsetHeight):
        //              windowSize == "sm" ? 0 :
        //              "english" == "japanese" ? 180: 170;
        yPosition -= (windowSize == "xs" || document.querySelector('.site-logo-wrapper').offsetHeight == 0) ? parseInt(document.querySelector(".site-header-menu").offsetHeight):
                    windowSize == "sm" ? 0 :
                    window.location.href.indexOf("/ja") != -1 ? 180: 170;
                    //if (window.location.href.indexOf("/ja") != -1)
        $('.offcanvas-main').animate({
          scrollTop: yPosition
        }, 1000);
      },

      uniqueArray: function(arr){
        var n = {},r=[];
        for(var i=0; i<arr.length;i++){
          if (!n[arr[i]]){
            n[arr[i]] = true;
            r.push(arr[i]);
          }
        }
        return r;
      }
    };

    },{}],3:[function(require,module,exports){
    var _ = require('./_lib.js');
    var cookies = require('./_cookies.js');

    var MetricSwitcher = function(){
      this.metricsSelector = "metrics";
      this.optionMetric = "metric";
      this.optionImperial = "imperial";
      this.cookieName = "unitSystem";
      this.notConverted = true;
      this.init();
    };


    MetricSwitcher.prototype.init = function() {
      var spans = document.querySelectorAll('span.metric, span.inches, span.milli, span.weight, span.weightKG')
      _.each(spans, function(span){
        span.dataset.metric = span.innerHTML;
      });
      this._addEventListeners();
      if(cookies.getItem(this.cookieName)==this.optionImperial)
      {
        this.convertToImperial();
        document.getElementById(this.metricsSelector).value= this.optionImperial;
        this.notConverted = false;
        this.switchUnit(this.optionImperial);
      }
    };

    MetricSwitcher.prototype._addEventListeners = function () {
      var _this = this;
      var selectMetric = document.getElementById(this.metricsSelector);
      if (selectMetric) {
        selectMetric.addEventListener('change', function () {
          if (_this.notConverted && this.value==_this.optionImperial) {
            _this.convertToImperial();
            _this.notConverted = false;
          }
          _this.switchUnit(this.value);
          var expiryDate = new Date();
          expiryDate.setDate(expiryDate.getDate() + 30);
          cookies.setItem(_this.cookieName, this.value, expiryDate, '/');


          //change the value inside CustomerSetting
          if(CoreInit.Template == "cart"){

            var customerSettString = document.getElementById('CustomerSetting').innerHTML;
            var metricValue;
            this.metricSwitcher = new MetricSwitcher();
            if(!this.metricSwitcher.notConverted){
              metricValue = "/UScu";
            }else{
              metricValue = "/SI";
            }

            document.getElementById("CustomerSetting").value = customerSettString .replace(/\/([^\/]*)$/,metricValue);
            document.getElementById("CustomerSetting").innerHTML = customerSettString .replace(/\/([^\/]*)$/,metricValue);
            // //Update new site : Re arrange the order in order to have them in the correct order in the string
            // var customerSetting = "";
            // // Initialize country switcher with cookies
            // this.countrySwitcher = new CountrySwitcher();
            // this.cookieCountryName = this.countrySwitcher.cookieCountryName;
            // // this.cookieProvinceName = this.countrySwitcher.cookieProvinceName;
            // var tmp_country = cookies.getItem(this.cookieCountryName);
            // // var tmp_province = cookies.getItem(this.cookieProvinceName);
            // if(tmp_country != "---"){
            //   customerSetting += "/"+tmp_country;
            // }

            // // customerSetting += "/"+cookies.getItem(this.cookieCountryName);
            // customerSetting += "/"+ document.querySelector("html[lang]").getAttribute("lang");
            // // customerSetting += "/"+cookies.getItem(this.cookieCountryName);
            // customerSetting += "/"+ document.querySelector("html[data-currency-primary]").getAttribute("data-currency-primary");
            // // cookies.getItem("unitSystem")

            // this.metricSwitcher = new MetricSwitcher();
            // if(CoreInit.Template == "cart" && !this.metricSwitcher.notConverted){
            //   customerSetting += "/UScu";
            // }else{
            //   customerSetting += "/SI";
            // }
            // var elt_setting = document.getElementById('CustomerSetting');
            // if(elt_setting){
            //   elt_setting.innerHTML = customerSetting
            // }
          }

          //get all <span dt-selected-metric>
          var spansDtSelectedMetrics = document.querySelectorAll("span.dt-selected-metric");
          //error prevention
          if(spansDtSelectedMetrics){
            _.each(spansDtSelectedMetrics, function(spansDtSelectedMetric){
              //document.querySelector("#metrics").value
              spansDtSelectedMetric.innerHTML = document.querySelector("#metrics").value;
              spansDtSelectedMetric.setAttribute("dt-selected-metric", document.querySelector("#metrics").value);
            });
          }

        });
      }
    };

    MetricSwitcher.prototype.switchUnit = function (system) {
      var spans = document.querySelectorAll('span.metric, span.inches, span.milli, span.weight, span.weightKG')
      _.each(spans, function(span){
        span.innerHTML = span.dataset[system];
      });
    };


    MetricSwitcher.prototype.convertToImperial = function () {
      var spansMetrics = document.querySelectorAll('span.metric');
      _.each(spansMetrics, function(span){
        var size = span.dataset.metric.replace(" cm","").replace(/(\([0-9]*\.?[0-9]*\))/, "");
        if (size == "cm") {
          var attr = "ft and in";
        } else {
          var feet = Math.floor(size/30.48);
          var inch = feet < 3 ? Number(((size/2.54)%12).toFixed(1)): Math.min(11,Math.round((size/2.54)%12));
          var attr = feet > 0 ? feet + "'" + inch +"''": inch +"''";
        }
        span.dataset.imperial = attr;
        span.innerHTML = attr;
      });

      var spansInches = document.querySelectorAll('span.inches');
      _.each(spansInches, function(span){
        var size = span.dataset.metric.replace(" cm", "").replace(/(\([0-9]*\.?[0-9]*\))/, "");
        var inch = Number(((size / 2.54)).toFixed(1));
        var attr = (size == "cm") ? "in" : inch + "''";
        span.dataset.imperial = attr;
        span.innerHTML = attr;
      });

      var spanMilli = document.querySelectorAll('span.milli');
      _.each(spanMilli, function(span){
        var size = span.dataset.metric.replace(" mm","");
        var attr = (size == "mm") ? "mil" : Math.round(size/0.0254) + " mil";
        span.dataset.imperial = attr;
        span.innerHTML = attr;
      });

      var spanWeight = document.querySelectorAll('span.weight');
      _.each(spanWeight, function(span){
        var weight = span.dataset.metric.replace(" g","").replace(",","");
        var attr = (weight == "g") ? "oz" : Math.round(weight/28.35) + " oz";
        span.dataset.imperial = attr;
        span.innerHTML = attr;
      });

      var spanWeightKG = document.querySelectorAll('span.weightKG');
      _.each(spanWeightKG, function(span){
        var weight = span.dataset.metric.replace(" kg","");
        if (weight == "kg") {
          var attr = "kg";
        } else {
          var attr = weight/0.45359;
          attr = attr < 10 ? Number((attr).toFixed(1)):Math.round(attr);
          span.dataset.imperial = attr + " lb";
          span.innerHTML = attr + " lb";
        }
      });
    };

    var CountrySwitcher = function () {
      var _this = this;

      //Update 2020 August: put the country on the top of the list
      _this.putCountryToTheTop();
      _this.cookieCountryName = "cookieCountry";
      //this.countrySelector = document.getElementById('sidebar-tools-country');
      _this.countrySelector = document.getElementById('country_selector');
      _this.cookieProvinceName = "cookieProvince";
      _this.provinceSelector = document.getElementById('address_province');
      _this.cookieZip = "cookieZip";
      _this.zipSelector = document.getElementById("address_zip");
      _this._init();
      _this._addEventListeners();

    };


    CountrySwitcher.prototype.putCountryToTheTop = function () {
      //get a list of the countries to put on the top
      if(document.querySelector("span[data-top-country-list]")){
        var countrySplitted = document.querySelector("span[data-top-country-list]").getAttribute("data-top-country-list").split("/");
        var options = document.getElementById("country_selector");

        //Remove all options above ---
        $("#country_selector option").each(function(){
          if($(this).val()!= "---"){
            $(this).remove();
          }else{
            return false;
          }
        });

        //Insert all options above --- depending on the language of the shop
        $("#country_selector option").each(function(){
          for(var i=0; i<countrySplitted.length; i++){
            if($(this).val() == countrySplitted[i]){
              $(this).insertBefore($("option[value='---']"));
            }
          }
        });
      }

    }

    //use inside _initProvince
    function filterProv(str){
      if(str == "" || str == ","){
        return false;
      }else{
        return true;
      }
    }

    //get all the country provinces and cretae the options inside the select
    CountrySwitcher.prototype._initProvince = function () {
      //display the field
      $("#form_province").css("display","block");
      //reset the options if already exists inside the select
      $("#address_province option").remove();
      //add empty province
      $("#address_province").append('<option value="">---</option>');

      var getDataprov = document.querySelector("#country_selector option[value='"+this.countrySelector.value+"']").getAttribute("data-provinces");
      // getDataprov.split(/[\[\]]/g).filter(filterProv);
      var tabProv = getDataprov.split(/[\[\"\"\]]/g).filter(filterProv);
      for(var x=0; x<tabProv.length; x+=2){
        $("#address_province").append('<option value="'+tabProv[x]+'">'+tabProv[x+1]+'</option>');
      }
    }


    CountrySwitcher.prototype._init = function () {
      if (cookies.hasItem(this.cookieCountryName)) {
        var country = cookies.getItem(this.cookieCountryName);

        var province = cookies.getItem(this.cookieProvinceName);
        if (this.countryOptionExists(country)) {
          this.countrySelector.value = country;

          //if province depending of the country
          var country_option = this.countrySelector.querySelector('option[value="' + country + '"]');
          //length > 2, because we get a string, and the empty value is "[]" and check if province is empty

          if(country_option.getAttribute("data-provinces").length >2){
            this._initProvince();
            this.provinceSelector.value = province;
            this._saveUserProvince(province);
          }else{
            //if country cookie doesn't have any province, hide the field
            $("#form_province").css("display","none");
          }
          this._saveUserCountry(country);
          //update data-selected-country inside the html tag
          document.querySelector("[data-selected-country]").setAttribute("data-selected-country", country);
          // document.querySelector("[data-selected-country]").setAttribute("data-selected-country", country_option.innerHTML);

          //if inside account page, do the same for the create address form
          if(CoreInit.Template == "customers-addresses"){
            //The translated version, important to avoid an error in shopify-theme-addresses getFormElementsValue(formElements) function
            document.querySelector("#address_country_new").setAttribute("data-default", country_option.innerHTML);
            document.querySelector("#address_country_new").value = country;
            // if(province){
            //   document.querySelector("#address_province_new").setAttribute("data-default", province);
            //   var provinceOptionList = document.querySelector("#address_province_new").options;
            //   for(var i=0; i<provinceOptionList.length; i++){
            //     debugger;
            //     if(provinceOptionList[i].innerHTML == province){
            //       document.querySelector("#address_province_new").value = provinceOptionList[i].value;
            //     }
            //   }
            // }
          }

        }
        //if the chosen country does not exists inside the list anymore, reset to ---
        else{
          document.querySelector("[data-selected-country]").setAttribute("data-selected-country", "---");
          if(this.countrySelector){
            this.countrySelector.value = "---";
            document.querySelector("#country_selector").setAttribute("data-default", this.countrySelector.value);
            this._saveUserCountry(this.countrySelector.value);
            //hide the provinces because we do not select any country by default
          }
          $("#form_province").css("display","none");
        }
      } else {
        this.countrySelector.value = "---";
      }
      //Zip code
      if(cookies.hasItem(this.cookieZip) && cookies.getItem(this.cookieZip)!= null){
        var zipCookie = cookies.getItem(this.cookieZip);
        if(this.zipSelector){
          this.zipSelector.value = zipCookie;
          this._saveUserZip(zipCookie);
          //for the zip to appear correctly
          document.querySelector("label[for='address_zip']").classList.remove("display_none");
          document.querySelector("label[for='address_zip']").classList.add("floating-label");
          document.getElementById("address_zip").classList.add("has-floating-label");
        }
      }
      //show disclaimer of selected country if it exists
          var countryDisclaimer = document.querySelectorAll('[data-country-disclaimer="'+this.value+'"]');
          if (countryDisclaimer.length > 0) {
            countryDisclaimer[0].classList.remove("display_none");
          }

          if((!cookies.hasItem("disclaimer_customs") || cookies.getItem("disclaimer_customs") != this.value ) && list_countries_customs[this.value]){
            var customs_disclaimer = document.querySelector('[data-disclaimer="customs"]');
            if (customs_disclaimer){
              var shop_lang = document.querySelector("html[lang]").getAttribute("lang");
              if(shop_lang == "en" ){
                document.querySelector("#disclaimer-customs-country").innerHTML = list_countries_customs[this.value]["en"];
                document.querySelector("#disclaimer-customs-country-content").innerHTML = list_countries_customs[this.value]["content_en"];
              }else if(shop_lang == "fr"){
                document.querySelector("#disclaimer-customs-country").innerHTML = list_countries_customs[this.value]["fr"];
                document.querySelector("#disclaimer-customs-country-content").innerHTML = list_countries_customs[this.value]["content_fr"];
              }else{ //it's japanese site
                document.querySelector("#disclaimer-customs-country").innerHTML = list_countries_customs[this.value]["jp"];
                document.querySelector("#disclaimer-customs-country-content").innerHTML = list_countries_customs[this.value]["content_jp"];
              }
              if(CoreInit.Template == 'cart'){
                customs_disclaimer.style.display = "block";
                $(customs_disclaimer).insertAfter($(".offcanvas"));
                //save the current country inside disclaimer cookie
                _this._saveUserCountryDisclaimerCustoms(this.value);
              }
            }
          }
    };

    CountrySwitcher.prototype.countryOptionExists = function (country) {
      //return document.querySelector('#sidebar-tools-country option[value="' + country + '"]');
      //country can be equal to --- if old cookies. take this case into account
      if(country != "---"){
        return document.querySelector('#country_selector option[value="' + country + '"]');
      }else{
        //if country equal "---", take the first one in the options
        return document.querySelector('#country_selector option[value="' + document.querySelector("#country_selector option").value + '"]');
      }
    }

    CountrySwitcher.prototype._saveUserCountry = function(country_name) {
    // Set the cookie expiry to one year after today.
    var expiryDate = new Date();
    // expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    // Set the cookie expiry to one month after today.
    expiryDate.setDate(expiryDate.getDate() + 30);
    cookies.setItem(this.cookieCountryName, country_name, expiryDate, '/');
    //autofill checkout country if no account
      if(CoreInit.Template == 'cart' && country_name != "---"){
        var form_checkout = document.querySelector("form[action*='checkout?checkout[shipping_address][country]=']");
        if(form_checkout){
          form_checkout.action = form_checkout.action.replace(/\[country\]=.*/i,'[country]='+country_name);
        }
      }
    }


    CountrySwitcher.prototype._saveUserProvince = function(province) {
      // Set the cookie expiry to one year after today.
      var expiryDate = new Date();
      // expiryDate.setFullYear(expiryDate.getFullYear() + 1);
      expiryDate.setDate(expiryDate.getDate() + 30);
      cookies.setItem(this.cookieProvinceName, province, expiryDate, '/');
      // //set the attribute of the province selector
      document.getElementById("address_province").value = province;
      // document.getElementById("address_province").setAttribtue("data-default",province);
    }


    CountrySwitcher.prototype._saveUserZip = function(zip) {
      // Set the cookie expiry to one year after today.
      var expiryDate = new Date();
      // expiryDate.setFullYear(expiryDate.getFullYear() + 1);
      expiryDate.setDate(expiryDate.getDate() + 30);
      cookies.setItem(this.cookieZip, zip, expiryDate, '/');
    }

    CountrySwitcher.prototype._saveUserCountryDisclaimerCustoms = function(country_name) {
      // Set the cookie expiry to one year after today.
      var expiryDate = new Date();
      expiryDate.setFullYear(expiryDate.getFullYear() + 1);
      cookies.setItem("disclaimer_customs", country_name, expiryDate, '/');
    }

    CountrySwitcher.prototype._addEventListeners = function () {
      var _this = this;
      //in the cart
      var shipping_fees_country = document.getElementById("shipping-fees-country");
      //Event listen country selector
      if(this.countrySelector){
        this.countrySelector.addEventListener("change", function () {

          //reset le zip et le sauvegarde
          // _this.zipSelector.value = "";
          // _this._saveUserZip(_this.zipSelector.value);

          //reset le floating label
          // document.querySelector("label[for=address_zip]").classList.add("display_none");
          // document.querySelector("label[for=address_zip]").classList.remove("floating-label");

          // document.getElementById("address_zip").classList.remove("has-floating-label");

          //hide every country disclaimer
          _.each(document.querySelectorAll('[data-country-disclaimer]'),function(elt){
            elt.classList.add("display_none");
          });

          //update data-selected-country dans tag html
          var country_option = document.querySelector('#country_selector option[value="' + this.value + '"]');
          document.querySelector("[data-selected-country]").setAttribute("data-selected-country", this.value);
          // document.querySelector("[data-selected-country]").setAttribute("data-selected-country", country_option.innerHTML);
          //update CustomerSetting
          if(CoreInit.Template == "cart"){
            var customerSettString = document.getElementById('CustomerSetting').innerHTML;

            document.getElementById("CustomerSetting").value = customerSettString.replace(/\/.*?\//, "/"+this.value+"/");
            document.getElementById("CustomerSetting").innerHTML = customerSettString.replace(/\/.*?\//, "/"+this.value+"/");
          }


          //show disclaimer of selected country if it exists
          var countryDisclaimer = document.querySelectorAll('[data-country-disclaimer="'+this.value+'"]');
          if (countryDisclaimer.length > 0) {
            countryDisclaimer[0].classList.remove("display_none");
          }

          if((!cookies.hasItem("disclaimer_customs") || cookies.getItem("disclaimer_customs") != this.value ) && list_countries_customs[this.value]){
            var customs_disclaimer = document.querySelector('[data-disclaimer="customs"]');
            if (customs_disclaimer){
              var shop_lang = document.querySelector("html[lang]").getAttribute("lang");
              if(shop_lang == "en" ){
                document.querySelector("#disclaimer-customs-country").innerHTML = list_countries_customs[this.value]["en"];
                document.querySelector("#disclaimer-customs-country-content").innerHTML = list_countries_customs[this.value]["content_en"];
              }else if(shop_lang == "fr"){
                document.querySelector("#disclaimer-customs-country").innerHTML = list_countries_customs[this.value]["fr"];
                document.querySelector("#disclaimer-customs-country-content").innerHTML = list_countries_customs[this.value]["content_fr"];
              }else{ //it's japanese site
                document.querySelector("#disclaimer-customs-country").innerHTML = list_countries_customs[this.value]["jp"];
                document.querySelector("#disclaimer-customs-country-content").innerHTML = list_countries_customs[this.value]["content_jp"];
              }
              if(CoreInit.Template == 'cart'){
                customs_disclaimer.style.display = "block";
                $(customs_disclaimer).insertAfter($(".offcanvas"));
                //save the current country inside disclaimer cookie
                _this._saveUserCountryDisclaimerCustoms(this.value);
              }
            }
          }



          _this._saveUserCountry(this.value);


          //test if province exists, if it's the case, we save the first one
          //the first one because the select reset at the choice of a country
          var country_option = document.querySelector('#country_selector option[value="' + this.value + '"]');

          //length > 2, because we get a string, and the empty value is "[]"
          if(country_option.getAttribute("data-provinces").length >2 ){
            _this._initProvince();
            _this._saveUserProvince(document.querySelector("#address_province").value);
          }else{
            //if no province, reset the select and hide the field
            $("#address_province option").remove();
            $("#form_province").css("display","none");
          }


          if(shipping_fees_country){
            shipping_fees_country.innerHTML = this.options[this.selectedIndex].text;
            shipping_fees_country.setAttribute('data-country', this.value);
            var event = document.createEvent('HTMLEvents');
            event.initEvent('change', true, false);
            shipping_fees_country.dispatchEvent(event);
          }

          //add as a parameter for the cart-print ?
          //set all dt-selected-country
          //get all <span dt-selected-country>
          var spansDtSelectedCountries = document.querySelectorAll("span[dt-selected-country]");
          //error prevention
          if(spansDtSelectedCountries){
            _.each(spansDtSelectedCountries, function(spansDtSelectedCountry){
              spansDtSelectedCountry.innerHTML = country_option.innerHTML;
              spansDtSelectedCountry.setAttribute("dt-selected-country", country_option.innerHTML );
            });
          }

        });//end addEventListener Country
      }

      //workaround because of shopify update with currencies. When selected another language, just switch shop immediately
      if(document.getElementById("language_selector")){
        var shop_lang = document.querySelector("html[lang]").getAttribute("lang");
        document.querySelector(".disclaimer-content-text #language_selector").value = shop_lang;
        document.getElementById("language_selector").addEventListener("change", function (e){
          if(shop_lang != e.target.value){
            var changedURL;
            var url = window.location.href;
            if(e.target.value == "en" && (url.indexOf(".jp") != -1 || url.indexOf(".fr") != -1)){
              changedURL = url.replace(/(\.[a-z]+)(\.[a-z]+)/, "$1"+".com")
              window.location.replace(changedURL+"?currency=USD");
            }else if(e.target.value == "fr" && (url.indexOf(".jp") != -1 || url.indexOf(".com") != -1)){
              changedURL = url.replace(/(\.[a-z]+)(\.[a-z]+)/, "$1"+".fr")
              window.location.replace(changedURL);
            }else if(e.target.value == "ja" && (url.indexOf(".fr") != -1 || url.indexOf(".com") != -1)){
              changedURL = url.replace(/(\.[a-z]+)(\.[a-z]+)/, "$1"+".jp")
              window.location.replace(changedURL);
            }
          }

        });

      }

      //event listener on country selector disclaimer
      if(document.getElementById("country_selector_disclaimer")){
        document.getElementById("country_selector_disclaimer").addEventListener("change", function (){
          if((!cookies.hasItem("disclaimer_customs") || cookies.getItem("disclaimer_customs") != this.value ) && list_countries_customs[this.value]){
            var customs_disclaimer = document.querySelector('[data-disclaimer="customs"]');
            if (customs_disclaimer){
              var shop_lang = document.querySelector("html[lang]").getAttribute("lang");
              if(shop_lang == "en" ){
                document.querySelector("#disclaimer-customs-country").innerHTML = list_countries_customs[this.value]["en"];
                document.querySelector("#disclaimer-customs-country-content").innerHTML = list_countries_customs[this.value]["content_en"];
              }else if(shop_lang == "fr"){
                document.querySelector("#disclaimer-customs-country").innerHTML = list_countries_customs[this.value]["fr"];
                document.querySelector("#disclaimer-customs-country-content").innerHTML = list_countries_customs[this.value]["content_fr"];
              }else{ //it's japanese site
                document.querySelector("#disclaimer-customs-country").innerHTML = list_countries_customs[this.value]["jp"];
                document.querySelector("#disclaimer-customs-country-content").innerHTML = list_countries_customs[this.value]["content_jp"];
              }
              if(CoreInit.Template == 'cart'){
                customs_disclaimer.style.display = "block";
          		$(customs_disclaimer).insertAfter($(".offcanvas"));
                //save the current country inside disclaimer cookie
                _this._saveUserCountryDisclaimerCustoms(this.value);
              }
            }
          }
        });
      }

      //Event listen province selector
      if(this.provinceSelector){
        this.provinceSelector.addEventListener("change", function (){
          _this._saveUserProvince(this.value);
        });//end addEventListener province
      }

      //Event listen zip code
      if(this.zipSelector){
        this.zipSelector.addEventListener("change", function (){
          _this._saveUserZip(this.value);
        });//end addEventListener zip code
      }


    };

    var ShopTools = function () {
      this.autoLoadSelector = "sidebar-tools-pop";
      this.autoLoadButtonSelector = "[data-tools-autoselect]";
      this.country="";
      this.spanCountrySelector = "sidebar-tools-pop-country";
      this.spanCurrencySelector = "sidebar-tools-pop-currency";
      this.spanMetricSelector = "sidebar-tools-pop-metrics";
      this.countryInfos = {"US":{"name":"United State","currency":"USD","metric":"US customary units"},
                          "CA":{"name":"Canada","currency":"CAD","metric":"International System of Units"},
                          "AT":{"name":"Austria","currency":"EUR","metric":"International System of Units"},
                          "BE":{"name":"Belgium","currency":"EUR","metric":"International System of Units"},
                          "CY":{"name":"Cyprus","currency":"EUR","metric":"International System of Units"},
                          "EE":{"name":"Estonia","currency":"EUR","metric":"International System of Units"},
                          "FI":{"name":"Finland","currency":"EUR","metric":"International System of Units"},
                          "FR":{"name":"France","currency":"EUR","metric":"International System of Units"},
                          "DE":{"name":"Germany","currency":"EUR","metric":"International System of Units"},
                          "GR":{"name":"Greece","currency":"EUR","metric":"International System of Units"},
                          "IE":{"name":"Ireland","currency":"EUR","metric":"International System of Units"},
                          "IT":{"name":"Italy","currency":"EUR","metric":"International System of Units"},
                          "LV":{"name":"Latvia","currency":"EUR","metric":"International System of Units"},
                          "LT":{"name":"Lithuania","currency":"EUR","metric":"International System of Units"},
                          "LU":{"name":"Luxembourg","currency":"EUR","metric":"International System of Units"},
                          "MT":{"name":"Malta","currency":"EUR","metric":"International System of Units"},
                          "NL":{"name":"Netherlands","currency":"EUR","metric":"International System of Units"},
                          "PT":{"name":"Portugal","currency":"EUR","metric":"International System of Units"},
                          "SK":{"name":"Slovakia","currency":"EUR","metric":"International System of Units"},
                          "SI":{"name":"Slovenia","currency":"EUR","metric":"International System of Units"},
                          "ES":{"name":"Spain","currency":"EUR","metric":"International System of Units"},
                          "GB":{"name":"United Kingdom","currency":"GBP","metric":"International System of Units"},
                          "AU":{"name":"Australia","currency":"AUD","metric":"International System of Units"},
                          "CH":{"name":"Switzerland","currency":"CHF","metric":"International System of Units"},
                          "HK":{"name":"Hong Kong","currency":"HKD","metric":"International System of Units"},
                          "NZ":{"name":"New Zealand","currency":"NZD","metric":"International System of Units"},
                          "SG":{"name":"Singapore","currency":"SGD","metric":"International System of Units"},
                          "KR":{"name":"South Korea","currency":"KRW","metric":"International System of Units"},
                          "RU":{"name":"Russia","currency":"RUB","metric":"International System of Units"},
                          "MM":{"name":"Myanmar","currency":document.querySelector('[data-currency-primary]').getAttribute("data-currency-primary"),"metric":"US Customary Units"},
                          "LR":{"name":"Liberia","currency":document.querySelector('[data-currency-primary]').getAttribute("data-currency-primary"),"metric":"US Customary Units"},
                          "WORLD":{"name":"World","currency":document.querySelector('[data-currency-primary]').getAttribute("data-currency-primary"),"metric":"International System of Units"}
                          //  "MM":{"name":"Myanmar","currency":"JPY","metric":"US Customary Units"},
                          //  "LR":{"name":"Liberia","currency":"JPY","metric":"US Customary Units"},
                          //  "WORLD":{"name":"World","currency":"JPY","metric":"International System of Units"}
                          }

      //Update new site : Re arrange the order in order to have them in the correct order in the string
      var customerSetting = "";
      // Initialize country switcher with cookies
      var cookieCountryName  = "";
      this.countrySwitcher = new CountrySwitcher();
      this.cookieCountryName = this.countrySwitcher.cookieCountryName;
      this.metricSwitcher = new MetricSwitcher();
      // this.cookieProvinceName = this.countrySwitcher.cookieProvinceName;
      if(CoreInit.Template == "cart"){
        var tmp_country = cookies.getItem(this.cookieCountryName);
        // var tmp_province = cookies.getItem(this.cookieProvinceName);
        if(tmp_country && tmp_country != "---"){
          customerSetting += "/"+tmp_country;
        }

        // customerSetting += "/"+cookies.getItem(this.cookieCountryName);
        customerSetting += "/"+ document.querySelector("html[lang]").getAttribute("lang");
        // customerSetting += "/"+cookies.getItem(this.cookieCountryName);
        customerSetting += "/"+ document.querySelector("html[data-currency-primary]").getAttribute("data-currency-primary");
        // cookies.getItem("unitSystem")

        if(CoreInit.Template == "cart" && !this.metricSwitcher.notConverted){
          customerSetting += "/UScu";
        }else{
          customerSetting += "/SI";
        }
      }

      // var cookieprovinceName  = "";

      //to get the connection country, set the cookies etc
      this.init();

      //Save customers settings
      if(CoreInit.Template == "cart"){
        // if('USD CAD EUR GBP AUD CHF HKD NZD SGD KRW RUB' != ''){
        //   var tmp_curr = cookies.getItem("currency");
        //   if(tmp_curr != CoreInit.ShopCurrency){
        //     customerSetting += "/"+tmp_curr;
        //   }
        // }
        if(customerSetting != ""){
          var elt_setting = document.getElementById('CustomerSetting');
          if(elt_setting){
            elt_setting.innerHTML = customerSetting
          }
        }
      }

      //set value for all spans dt-selected...
      this.setSpansDt();

      //disabled all option with '---' to make them not selectable
      $("option[value='---']").each(function(){ $(this).prop("disabled",true) });

    }

    //Set all values of all spans with the following classes
  ShopTools.prototype.setSpansDt = function(){

    //get all <span dt-selected-country>
    var spansDtSelectedCountries = document.querySelectorAll("span[dt-selected-country]");
    //get the country
    var countryCookie = cookies.getItem(this.cookieCountryName);
    //search the country coookie inside the country list of the select
    // and get the translation
    if(document.getElementById("country_selector")){
      var countryOptionList = document.getElementById("country_selector").options;
      var countryTranslated;
      for(var i=0; i<countryOptionList.length; i++){
        if(countryOptionList[i].getAttribute("value") == countryCookie){
          countryTranslated = countryOptionList[i].innerHTML;
        }
      }
    }

    //error prevention
    if(spansDtSelectedCountries){
      _.each(spansDtSelectedCountries, function(spansDtSelectedCountry){
        //insert the country translated previously captured and insert it in the html and the attribute of all spans found
        spansDtSelectedCountry.innerHTML = countryTranslated;
        spansDtSelectedCountry.setAttribute("dt-selected-country", countryTranslated );
      });
    }

    //get all <span dt-selected-currency>
    var spansDtSelectedCurrencies = document.querySelectorAll("span[dt-selected-currency]");
    //error prevention
    if(spansDtSelectedCurrencies){
      _.each(spansDtSelectedCurrencies, function(spansDtSelectedCurrency){
        spansDtSelectedCurrency.innerHTML = document.querySelector("[data-currency-primary]").getAttribute("data-currency-primary");
        spansDtSelectedCurrency.setAttribute("dt-selected-currency", document.querySelector("[data-currency-primary]").getAttribute("data-currency-primary") );
      });
    }

    //get all <span dt-selected-language>
    var spansDtSelectedLanguages = document.querySelectorAll("span[dt-selected-language]").innerHTMl;
    //error prevention
    if(spansDtSelectedLanguages){
      _.each(spansDtSelectedLanguages, function(spansDtSelectedLanguages){
        spansDtSelectedLanguages.innerHTML = document.querySelector("[data-locale]").getAttribute("data-locale");
        spansDtSelectedLanguages.setAttribute("dt-selected-currency", document.querySelector("[data-locale]").getAttribute("data-locale") );
      });
    }

    //get all <span dt-selected-metric>
    var spansDtSelectedMetrics = document.querySelectorAll("span.dt-selected-metric");
    //error prevention
    if(spansDtSelectedMetrics){
      _.each(spansDtSelectedMetrics, function(spansDtSelectedMetric){
        //document.querySelector("#metrics").value
        spansDtSelectedMetric.innerHTML = document.querySelector("#metrics").value;
        spansDtSelectedMetric.setAttribute("dt-selected-metric", document.querySelector("#metrics").value);
      });
    }
  }

  ShopTools.prototype.init = function() {
    var _this = this;

    //get the country detected by Shopify
    var country, countryNotTranslated ;
    var ajaxCountry = new XMLHttpRequest();
    ajaxCountry.open("get", "/browsing_context_suggestions.json?source=locale_bar_app&currency[enabled]=true",true);
    ajaxCountry.send();
    ajaxCountry.addEventListener('load', function (e) {
      countryNotTranslated = JSON.parse(this.responseText)["detected_values"]["country_name"];
      //search the country string inside the country list of the select
      if(document.getElementById("country_selector")){
        var countryOptionList = document.getElementById("country_selector").options;
        for(var i=0; i<countryOptionList.length; i++){
          if(countryOptionList[i].innerHTML == countryNotTranslated){
            country = countryOptionList[i].getAttribute("value");
          }
        }
      }


      var countryHandle = JSON.parse(this.responseText)["detected_values"]["country"]["handle"];
      // country = infoCountriesJSon.isoCountries[countryHandle];

      document.querySelector('[data-geolocation-country]').setAttribute("data-geolocation-country",country);
      if(!cookies.hasItem(_this.cookieCountryName)){
        document.querySelector("#country_selector").value = country;
        document.querySelector("#country_selector").setAttribute("data-default",country);
      }

      //var queryString = window.location.search --> get url parameters, if empty, display disclaimer
      var queryString = window.location.search;
      //check if url got parameters and cookie, if not, display the disclaimer
      if(!cookies.hasItem(_this.cookieCountryName) && (!queryString || queryString == "?_ab=0&_fd=0&_sc=1")){
        var disclaimer = document.querySelector('.disclaimer.disclaimer-japan');
        var urlParams = new URLSearchParams(queryString);
        var currencyParam = urlParams.get("currency");
        // if(disclaimer){
        //   disclaimer.style.display = "block";
        // }
        if((country == "France" && window.location.href.indexOf(".fr") != -1) || (country == "Japan" && window.location.href.indexOf(".jp") != -1) ||currencyParam){
          disclaimer.style.display = "none";
          _this.countrySwitcher._saveUserCountry(country);
        }else if(disclaimer){
          disclaimer.style.display = "block";
        }
        //here we set up the disclaimer
        //change the country name
        // document.querySelector(".disclaimer-content-text p span[data-country]").innerHTML = country;

        //put the detected country connection into the span of the disclaimer
        var countryTrad = document.querySelector('#country_selector option[value="'+country+'"]').innerHTML;
        document.querySelector(".disclaimer .detected-country-name").innerHTML = countryTrad;
        //set the value of all the select
        //--- country selector
        document.querySelector(".disclaimer-content-text #country_selector_disclaimer").setAttribute("data-default",country);
        document.querySelector(".disclaimer-content-text #country_selector_disclaimer").value = country;
        //--- Language selector
        //get option with the value equel to the language set for the detected country
        var jsonLanguage = infoCountriesJSon.countries[country].language;

        if(jsonLanguage == "JA"){
          document.querySelector(".disclaimer-content-text #language_selector").setAttribute("data-default","ja");
          document.querySelector(".disclaimer-content-text #language_selector").value = "ja";
        }else if(jsonLanguage == "FR"){
          document.querySelector(".disclaimer-content-text #language_selector").setAttribute("data-default","fr");
          document.querySelector(".disclaimer-content-text #language_selector").value = "fr";
        }else{
          document.querySelector(".disclaimer-content-text #language_selector").setAttribute("data-default","en");
          document.querySelector(".disclaimer-content-text #language_selector").value = "en";
        }

        // if(window.location.href.indexOf(".com") != -1){
        //   document.querySelector(".disclaimer-content-text #language_selector").setAttribute("data-default","en");
        //   document.querySelector(".disclaimer-content-text #language_selector").value = "en";
        // }else if(window.location.href.indexOf(".fr") != -1){
        //   document.querySelector(".disclaimer-content-text #language_selector").setAttribute("data-default","fr");
        //   document.querySelector(".disclaimer-content-text #language_selector").value = "fr";
        // }else{
        //   //jp
        //   document.querySelector(".disclaimer-content-text #language_selector").setAttribute("data-default","ja");
        //   document.querySelector(".disclaimer-content-text #language_selector").value = "ja";
        // }
        //--- Currency selector
        var jsonCurrency = infoCountriesJSon.countries[country].currency;

        // document.querySelector(".disclaimer-content-text #currency_selector").setAttribute("data-default",jsonCurrency);
        // document.querySelector(".disclaimer-content-text #currency_selector").value = jsonCurrency;
        var country_found = false;
        for (i = 0; i < document.getElementById("currency_selector").length; ++i){
          if (document.getElementById("currency_selector").options[i].value == countryHandle){
            country_found = true;
          }
        }

        if(country_found){
          var currentCurrency = document.querySelector('[data-currency-primary]').getAttribute("data-currency-primary")
          document.querySelector(".disclaimer-content-text #currency_selector").setAttribute("data-default",countryHandle);
          document.querySelector(".disclaimer-content-text #currency_selector").value = countryHandle;
          document.querySelector('.disclaimer #disclaimer_localization_form input[name="country_code"]').setAttribute("value",countryHandle);
        }else{
          document.querySelector(".disclaimer-content-text #currency_selector").setAttribute("data-default","AO");
          document.querySelector(".disclaimer-content-text #currency_selector").value = "AO";
          document.querySelector('.disclaimer #disclaimer_localization_form input[name="country_code"]').setAttribute("value","AO");
        }

        //update shopify for currencies, put the auto selected currency by default
        //--- Metrics selector
        var jsonMetrics = infoCountriesJSon.countries[country].metrics;

        document.querySelector(".disclaimer-content-text #metrics").setAttribute("data-default",jsonMetrics.toLowerCase());
        document.querySelector(".disclaimer-content-text #metrics").value = jsonMetrics.toLowerCase();
        //if no cookies and get url parameters
      }else if(!cookies.hasItem(_this.cookieCountryName) && queryString){
        //here we get all the parameters and save them as cookies
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        var currencyParam = urlParams.get("currency");
        var metricsParam = urlParams.get("metrics");
        var countryParam = urlParams.get("country");

        if(currencyParam){
          //since we filter currency, take the one that exists in our list
          document.querySelector(".disclaimer-content-text #currency_selector").setAttribute("data-default","AO");
          document.querySelector(".disclaimer-content-text #currency_selector").value = "AO";
          document.querySelector('.disclaimer #disclaimer_localization_form input[name="country_code"]').setAttribute("value","AO");
        }

        //save country inside the cookies
        _this.countrySwitcher._saveUserCountry(countryParam);
        //use to init the province selector
        _this.countrySwitcher._init();
        //save metrics in cookies
        var expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + 30);

        cookies.setItem(_this.metricSwitcher.cookieName, metricsParam, expiryDate, '/');

        //set country in country selector
        document.querySelector("#country_selector").value = countryParam;
        document.querySelector("#country_selector").setAttribute("data-default",countryParam);

        //set metrics in metrics selector
        document.querySelector("#metrics").value = metricsParam;
        document.querySelector("#metrics").setAttribute("data-default",metricsParam);
      }

      //list_countries_customs is initialize in site-disclaimers.liquid
      var country_name = country;
      if(list_countries_customs[document.getElementById("country_selector").value]){
        country_name = document.getElementById("country_selector").value;
      }
      if((!cookies.hasItem("disclaimer_customs") || cookies.getItem("disclaimer_customs") != country_name ) && list_countries_customs[country_name]){
        var customs_disclaimer = document.querySelector('[data-disclaimer="customs"]');
        if (customs_disclaimer){
          var shop_lang = document.querySelector("html[lang]").getAttribute("lang");
          if(shop_lang == "en" ){
            document.querySelector("#disclaimer-customs-country").innerHTML = list_countries_customs[country_name]["en"];
            document.querySelector("#disclaimer-customs-country-content").innerHTML = list_countries_customs[country_name]["content_en"];
          }else if(shop_lang == "fr"){
            document.querySelector("#disclaimer-customs-country").innerHTML = list_countries_customs[country_name]["fr"];
            document.querySelector("#disclaimer-customs-country-content").innerHTML = list_countries_customs[country_name]["content_fr"];
          }else{ //it's japanese site
            document.querySelector("#disclaimer-customs-country").innerHTML = list_countries_customs[country_name]["jp"];
            document.querySelector("#disclaimer-customs-country-content").innerHTML = list_countries_customs[country_name]["content_jp"];
          }
          if(CoreInit.Template == 'cart'){
            customs_disclaimer.style.display = "block";
            $(customs_disclaimer).insertAfter($(".offcanvas"));
            //save the current country inside disclaimer cookie
          }
          _this.countrySwitcher._saveUserCountryDisclaimerCustoms(country_name);
        }
      }

    });


    //disclaimer window : get all the informations when clicking on the confirm or close button
    if(!cookies.hasItem(this.cookieCountryName)){
      var divAutoLoad = document.getElementById(this.autoLoadSelector);
      var autoLoadButtons = document.querySelectorAll(this.autoLoadButtonSelector);
      //add eventListener on close button ----> keep default url, currency and metric
      var buttonCloseDisclaimer = document.querySelector(".disclaimer .close-disclaimer");
      buttonCloseDisclaimer.addEventListener("click", function(){
        if(this == document.querySelector(".disclaimer  .close-disclaimer")){
          //get default data (avoid reloading page)
          var defaultCountry = document.querySelector(".disclaimer-content-text #country_selector_disclaimer").getAttribute("data-default");
          var defaultLanguage = document.querySelector("html[data-locale]").getAttribute("data-locale");
          var defaultCurrency = document.querySelector(".disclaimer-content-text #currency_selector").getAttribute("data-default");
          var defaultMetrics = document.querySelector(".disclaimer-content-text #metrics").getAttribute("data-default");

          //save in cookies
          //save country
          _this.countrySwitcher._saveUserCountry(defaultCountry);
          //use to init the province selector
          _this.countrySwitcher._init();
          //save metrics in cookies
          var expiryDate = new Date();
          expiryDate.setDate(expiryDate.getDate() + 30);
          cookies.setItem(_this.metricSwitcher.cookieName, defaultMetrics, expiryDate, '/');
        }
      });
      //add eventListener on confirm button
      var buttonDisclaimer = document.querySelector(".disclaimer a.button.button-secondary");
      buttonDisclaimer.addEventListener('click', function(){
        if(this == document.querySelector(".disclaimer .disclaimer-actions a.button.button-secondary")){

          //country
          document.querySelector("#country_selector").value = document.querySelector(".disclaimer-content-text #country_selector_disclaimer").value;
          var countrySelected = document.querySelector(".disclaimer-content-text #country_selector_disclaimer").value;
          // var countrySelected = country;
          document.querySelector("#country_selector").setAttribute("data-default",countrySelected);


          var shopify_country = document.querySelector('[data-geolocation-country]').getAttribute("data-geolocation-country");
          document.querySelector("#country_selector").value = shopify_country;
          document.querySelector("#country_selector").setAttribute("data-default",shopify_country);


          //language
          document.querySelector("#language_selector").value = document.querySelector(".disclaimer-content-text #language_selector").value;
          var languageSelected = document.querySelector(".disclaimer-content-text #language_selector").value;
          // var defaultLanguage = document.querySelector(".disclaimer-content-text #language_selector").getAttribute("data-default");
          //get the language from the attributes of the html tag
          var defaultLanguage = document.querySelector("html[data-locale]").getAttribute("data-locale");
          document.querySelector("#language_selector").setAttribute("data-default",languageSelected);


          //currency
          document.querySelector("#currency_selector").value = document.querySelector(".disclaimer-content-text #currency_selector").value;
          var currencySelected = document.querySelector(".disclaimer-content-text #currency_selector").value;

          var defaultCurrency = document.querySelector('[data-currency-primary]').getAttribute("data-currency-primary");
          document.querySelector("#currency_selector").setAttribute("data-default",currencySelected);


          //metrics
          document.querySelector("#metrics").value = document.querySelector(".disclaimer-content-text #metrics").value;
          var metricsSelected = document.querySelector(".disclaimer-content-text #metrics").value;
          document.querySelector("#metrics").setAttribute("data-default",metricsSelected);


          //save country in cookies
          _this.countrySwitcher._saveUserCountry(countrySelected);
          //use to init the province selector
          _this.countrySwitcher._init();
          //save metrics in cookies
          var expiryDate = new Date();
          expiryDate.setDate(expiryDate.getDate() + 30);

          cookies.setItem(_this.metricSwitcher.cookieName, metricsSelected, expiryDate, '/');

          //remove display of the disclaimer
          // document.querySelector('.disclaimer.disclaimer-japan').style.display = "none";
          if(languageSelected != defaultLanguage && languageSelected){
            //get the current url
            var url = window.location.href;
            //will contain the changed url depending on the language chosen
            var changedURL;

            //change url if language is different than the website url language
            if(languageSelected == "en" && (url.indexOf(".jp") != -1 || url.indexOf(".fr") != -1)){
              changedURL = url.replace(/(\.[a-z]+)(\.[a-z]+)/, "$1"+".com").replace(/[#]/g,"")
              window.location.replace(changedURL+"?currency=USD"+"&country="+countrySelected);
            }else if(languageSelected == "fr" && (url.indexOf(".jp") != -1 || url.indexOf(".com") != -1)){
              changedURL = url.replace(/(\.[a-z]+)(\.[a-z]+)/, "$1"+".fr")
              window.location.replace(changedURL+"&country="+countrySelected);
            }else if(languageSelected == "ja" && (url.indexOf(".fr") != -1 || url.indexOf(".com") != -1)){
              changedURL = url.replace(/(\.[a-z]+)(\.[a-z]+)/, "$1"+".jp")
              window.location.replace(changedURL+"&country="+countrySelected);
            }
            // --------------------------------- temporary, because the url will change ---------------------------------
            //if language is EN, no need to insert in the url the language
            // if(languageSelected != "en"){
            //   //put between https:// and the url the language
            //   //if(url.indexOf(".jp") != -1 || url.indexOf(".fr") != -1){
            //   //if there's .jp or .fr, the split length is 3
            //   if(url.split(".").length > 2){
            //     changedURL = url.replace(/(\/\/)([a-z]+\.)/, "$1"+languageSelected+".");
            //   }else{
            //     changedURL = url.replace(/(\/\/)/, "$1"+languageSelected+".");
            //   }
            // }else{
            //   //delete between https:// and the the url domain name (remove "jp." or "fr.")
            //   changedURL = url.replace(/(\/\/)([a-z]+\.)/, "$1");
            // }
            //currency parameter in the url
            // changedURL += "?currency="+currencySelected;

            //metrics parameter in the url
            // changedURL += "&metrics="+metricsSelected;


            //add the country to the url
            // window.location.href = changedURL+"&country="+countrySelected;
            // window.location.replace(changedURL+"&country="+countrySelected);

          }else{

            //currencySelected == "" mean we cannot select it
            if(currencySelected != defaultCurrency && currencySelected !=""){
              // window.location.href = "/?currency="+currencySelected;
              // debugger;
              var input_form = document.querySelector('.disclaimer #disclaimer_localization_form input[name="country_code"]')
              input_form.value = currencySelected;
              var form = document.querySelector('.disclaimer #disclaimer_localization_form');
              //window.location.replace("/?currency="+currencySelected);
              if(form) form.submit();
            }
          }
          // if(languageSelected != "en"){
          //   window.location.replace("/"+languageSelected+"/?currency="+currencySelected);
          // }else{
          //   if(currencySelected != defaultCurrency){
          //     window.location.href = "/?currency="+currencySelected;
          //   }
          // }
        }
      });
      // _.each(autoLoadButtons, function(btn){
      //   btn.addEventListener('click', function(){
      //     // divAutoLoad.classList.add("display_none");
      //     // if(btn.dataset.toolsAutoselect=="all"){
      //       // if(_this.countrySwitcher.loadCountrySelector(_this.countryInfos[_this.country_code].name)){
      //       //   _this.countrySwitcher._saveUserCountry(_this.countryInfos[_this.country_code].name);
      //       // }

      //       //   var country_info = _this.countryInfos[_this.country_code]||_this.countryInfos["WORLD"];
      //       //   metricSelect.value= country_info["metric"]=="International System of Units"?"metric":"imperial";
      //       //   var event = document.createEvent('HTMLEvents');
      //       //   event.initEvent('change', true, false);
      //       //   metricSelect.dispatchEvent(event);

      //       // if('USD CAD EUR GBP AUD CHF HKD NZD SGD KRW RUB' != ''){
      //       //   currencySelect.value = country_info["currency"];
      //       //   currencySelect.dispatchEvent(event);
      //       // }
      //     // }

      //     //if click on the disclaimer button confirm
      //   })
      // })
    }

    if(document.getElementById("localization_form")){
      document.querySelector("#CurrencyList").addEventListener('change', function (e) {
        var localization_change_value = e.currentTarget.value;
        if(localization_change_value === "AO"){
            location.href += '?currency=JPY';
        }
      });
    };
  };

    module.exports = ShopTools;

    },{"./_cookies.js":1,"./_lib.js":2}],4:[function(require,module,exports){
    var _ = require('./_lib.js');
    var ShopTools = require('./_shop-tools.js');

    var FeaturesJs = function (){
      _.ready(function () {
          new ShopTools();
      });
    }

    window.FeaturesJs = new FeaturesJs();

    },{"./_lib.js":2,"./_shop-tools.js":3}]},{},[4]);
});// fin ajax
